import React from 'react';
import { useParams } from 'react-router-dom';

// Statically import the language-specific components for better SEO.
import AboutEN from './About_en';
import AboutHE from './About_he';
import AboutES from './About_es';
import AboutRU from './About_ru';

const About = () => {
  const { lang } = useParams();

  let LanguageSpecificComponent;

  switch (lang) {
    case 'he':
      LanguageSpecificComponent = AboutHE;
      break;
    case 'es':
      LanguageSpecificComponent = AboutES;
      break;
    case 'ru':
      LanguageSpecificComponent = AboutRU;
      break;
    case 'en':
    default:
      LanguageSpecificComponent = AboutEN;
      break;
  }

  return <LanguageSpecificComponent />;
};

export default About;
